export default function (context) {
  return {
    httpEndpoint: '/api/graphql',
    httpLinkOptions: {
      credentials: 'include',
    },
    persisting: true,
  }
}
